export default __webpack_public_path__ + "static/media/r3aa_thumb.6909be34.jpg";